/* eslint-disable import/prefer-default-export */
import { reactive } from 'vue';

type StyleType = Record<string, object | string | number | null | undefined>;

export const createStyle = (
  style: StyleType,
  options: { asReactive?: boolean } = {},
): StyleType => {
  const { asReactive = false } = options;
  return asReactive ? reactive(style) : style;
};
